import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { ApiQueryParams } from '@/pages/OperationsInsights/types/ApiQueryParams';
import { ApiRespBacklogAgeBandsByBuckets } from '@/pages/OperationsInsights/types/BacklogMetricsResponse';
import { transformDateIntoLocalString } from '@/utils';

export const fetchBacklogAgeBandsByBuckets = async (params: ApiQueryParams): Promise<ApiRespBacklogAgeBandsByBuckets> => {
    // This is to covert the beginning of the day in user time.
    const fromDate = transformDateIntoLocalString(params.fromDate);
    const toDate = transformDateIntoLocalString(params.toDate);
    const fetchUrl =
        '/workactivity/back-office/backlog/snapshot/age-bands/buckets?' +
        `fromDate=${fromDate}&toDate=${toDate}&workstreamDefinitionIds=${params.workstreamDefinitionIds.join(',')}`;
    const resp = await fetchFromLambda(fetchUrl);
    return resp as ApiRespBacklogAgeBandsByBuckets;
};
